<template>
    <div class="page-setting has-bc biz-home-default">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
        </div>
        <short-cut-comp></short-cut-comp>
    </div>
</template>
<script>
import shortCutComp from '@/components/bussiness/personalHome/home/shortCut/shortCutComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {

        }
    },
    computed: {
        ...mapGetters({
        })
    },
    components: {
        shortCutComp
    }
}
</script>
<style lang="scss">
    // .biz-home-default{
    //     .biz-home-default-wrap{
            
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalHome/home/shortCut.vue